<template>
    <v-container class="pa-0">
        <company-unavailable />
        <no-phone-set />
        <subscription-status />
        <v-row>
            <v-col cols="12">
                <select-option-students :custom-options="options" @change="onChangeOption" :value="option" class="mb-3"/>
                <student-progress-table v-show="option === 'student'" no-title :coach-id="coachId" :alert-student-ids="alertStudentIds" />
                <home-team-dashboard v-if="teamEverOpened" v-show="option === 'team'" :coach-id="coachId" />
                <home-agenda-panel v-if="isMobile" />
            </v-col>
        </v-row>

        <!-- AI Chat -->
        <ai-chat-drawer ref="aiChat" />

    </v-container>
</template>

<script>

import NoPhoneSet from "@/components/elements/alerts/NoPhoneSet";
import CompanyUnavailable from "@/components/elements/alerts/CompanyUnavailable";
import SubscriptionStatus from "@/components/student/SubscriptionStatus";
import StudentProgressTable from "@/components/student/StudentProgressTable";
import SelectOptionStudents from '../../components/coach/SelectOptionStudents.vue';
import HomeTeamDashboard from '../../components/coach/HomeTeamDashboard.vue';
import HomeAgendaPanel from '../../components/coach/HomeAgendaPanel.vue';
import AiChatDrawer from '@/components/coach/ai/AiChatDrawer';

export default {
    components: {
        NoPhoneSet,
        CompanyUnavailable,
        SubscriptionStatus,
        StudentProgressTable,
        SelectOptionStudents,
        HomeTeamDashboard,
        HomeAgendaPanel,
        AiChatDrawer,
    },
    data() {
        return {
            options: [
                { name: `${this.$t('common.student')}s`, value: 'student', icon: 'mdi-account' },
                { name: `${this.$t('common.team')}s`, value: 'team', icon: 'mdi-account-group', feature: 'teamsPanel' }
            ],
            option: 'student',
            teamEverOpened: false,
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.currentUser?.uid || null
        },
        alertStudentIds(vm = this) {
            return (vm.unreadAlertsList || []).map(a => a.studentId)
        },
    },
    methods: {
        onChangeOption(option) {
            const vm = this
            vm.option = option
            if (option === 'team') vm.teamEverOpened = true
        },
    },
}
</script>

<style scoped>
</style>
